module.exports = __webpack_public_path__ + "static/media/foto3.6b1636e5.png";